import React from 'react';
import styles from './W_FAQBlock.module.css';
import M_FAQAccordionItem from '@/components/M_Molecules/M_FAQAccordionItem/M_FAQAccordionItem';
import { M_FAQAccordionItemProps } from '@/components/M_Molecules/M_FAQAccordionItem/M_FAQAccordionItem';

export interface W_FAQBlockProps {
  title: string;
  icon: React.ReactNode;
  items: M_FAQAccordionItemProps[];
}

export default function W_FAQBlock({ title, icon, items }: W_FAQBlockProps) {
  return (
    <div className={styles.wrapper}>
      <div className={styles.header}>
        {icon}
        <h3 className={styles.title}>{title}</h3>
      </div>
      <div className={styles.items}>
        {items.map(item => (
          <M_FAQAccordionItem
            key={item.title}
            title={item.title}
            description={item.description}
          />
        ))}
      </div>
    </div>
  );
}
